import React from 'react'
import { I18n } from '@front/volcanion'

import { Typography, Grid, Box } from '@mui/material'
import { ModelMenuSelectorField, MenuSelectorField } from '@front/squirtle'

import CPUtils from '@front/squirtle/utils/CPUtils'

const Title = props =>
  <Grid size={12}>
    <Typography variant={'h5'}> {I18n.t('commercialpackage.search')} </Typography>
  </Grid>

const Row1 = ({ applicable_load, ...props }) =>
  <Grid container justifyContent="center" spacing={1} size={12}>
    <Grid size="grow">
      <ModelMenuSelectorField
        name='commercial_package_id'
        label={I18n.t('commercialpackage.label', { count: -1 })}
        model_name='commercialpackage'
        config={{
          mutator: cp => ({ ...CPUtils.getTranslatedLabel(cp), ...cp })
        }}
        searchMode={'search'}
        loadOnMount
        multiple
      />
    </Grid>
    <Grid size="grow">
      <MenuSelectorField
        label={I18n.t('load.label', { count: 1 })}
        name={'load_type'}
        selectFirst
        options={[
          { label: I18n.t('load.user.label', { count: -1 }), value: 'user' },
          { label: I18n.t('load.package.label', { count: -1 }), value: 'package' }
        ]}
      />
    </Grid>
    <Grid size="grow">
      <ModelMenuSelectorField
        name={'authorized_formulas'}
        label={I18n.t('commercial_formula.label', { count: -1 })}
        model_name='commercialformula'
        labelKeys={['name']}
        multiple
        loadOnMount
        searchMode={'search'}
        config={{ sortKeys: ['display_index'], sortOrders: ['asc'] }}
      />
    </Grid>
  </Grid>

const SearchForm = props =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Title />
      <Row1 />
    </Grid>
  </Box>

export default React.memo(SearchForm)
